<template>
  <div style="height: 100vh; width: 100%">
    <div style="width: 100%; display: none; height: 0%">
      <img id="imageid" :src="profpic" />
      <canvas id="imgCanvas" />
      <pdf-make
        ref="pdfMake"
        style="width: 100%"
        :content="content"
        :pageSize="'A4'"
        :pageOrientation="'portrait'"
        :show="true"
        :info="{ title: title }"
        @change="
          (e) => {
            src = e;
          }
        "
      >
      </pdf-make>
    </div>
    <iframe
      id="content-frame"
      :src="src"
      style="width: 100%; display: inline-block; height: 100%"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import PdfMake from "@/components/PdfMake";
import { docContent } from "@/data/TemplateKajianMedis.js";
// import ttf from 'url-loader!@/assets/微软雅黑.ttf'
//console.log(ttf)
export default {
  name: "DocKajianMedis",
  components: {
    PdfMake,
  },
  data() {
    return {
      title: "Kajian Medis",
      src: "",
      content: [],
      profpic: "https://103.27.207.58/backend/public/images/icon_customer.png",
    };
  },
  methods: {
    executeDocument: function() {
      document.getElementById("content-frame").contentWindow.window.print();
    },
    toDataUrl: function(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.content = docContent;
  },
};
</script>
